import AddUnit from "../../../Components/Pricings/Uoms/AddUnit";

export default function CreateUom(){
    return(
        <AddUnit/>
    )
}